module.exports = __webpack_public_path__ + "img/partner20.1dde85c6.png";